import { useGetStream } from '@vlabs/api/artemy/client';
import type { GroupId, StreamId } from '@vlabs/api/artemy/model';

// Источник всегда ровно в одной группе. Бэк не отдаёт groups вместе с enriched=0
// (и игнорирует targets при enriched=0), поэтому группа запрашивается отдельным
// запросом только с targets=['groups'] — groups[0] это сразу group_id.
export function useStreamGroupId(streamId: StreamId): GroupId | undefined {
  const getStreamGroups = useGetStream(streamId, { targets: ['groups'] });

  return getStreamGroups.data?.groups?.[0];
}
